"use client"

import { CornerLeftUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CornerLeftUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CornerLeftUpIcon = component(Icon)({ as: CornerLeftUp })
